import React from 'react';

const BlockedSubscriptionRepresentant = () => {
  return (
    <div className="container" id="main">
      <div className="column text-center bg-white p-3 mt-5">
        <div id="notfound">
          <p>
            <i className="big-icon material-icons mb-2">lock</i>
          </p>
          <h4>
            A empresa que você está representando não pode acessar este serviço no momento. Entre em
            contato com o administrador da conta.
          </h4>
        </div>
      </div>
    </div>
  );
};

export default BlockedSubscriptionRepresentant;
